import React from "react";
import * as T from "prop-types";

import { Field, Inputs } from "2g-form";

import { DATA } from "b2b/api/paths";
import { Smlouva } from "b2b/renderers/ciselnik/";

import useMessages from "./i18n/useMessages";

export function ACZakaznikSmlouvy({ zakaznikICO, ...props }) {
  const { smlouvyLabel, smlouvyPlaceholder } = useMessages();

  return (
    <Field
      component={Inputs.AutoComplete}
      url={DATA.smlouvy(zakaznikICO)}
      rendererSelected={Smlouva}
      rendererOption={Smlouva}
      loadOnce
      staticKey={["nazevCz, nazevEn"]}
      minChars={0}
      label={smlouvyLabel()}
      placeholder={smlouvyPlaceholder()}
      descriptionRenderer={Smlouva}
      {...props}
    />
  );
}

ACZakaznikSmlouvy.propTypes = {
  zakaznikICO: T.number,
  multiple: T.bool
};

export default React.memo(ACZakaznikSmlouvy);
